import script from "./CheckoutOrderSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutOrderSummary.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutOrderSummary.vue?vue&type=style&index=0&id=ad3db438&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad3db438"]])

export default __exports__